export enum MedicalCaseState {
  INIT = 'INIT',
  DOCUMENT_PROCESSING = 'DOCUMENT_PROCESSING',
  DOSSIER_GENERATED = 'DOSSIER_GENERATED',
  SECOND_OPINION_PENDING = 'SECOND_OPINION_PENDING',
  SECOND_OPINION_READY = 'SECOND_OPINION_READY',
}
